import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import AfitdButton from '../../../common/elemental/AfitdButton';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { setClassNameInDefns } from '../../../common/definitionHelper';
import { Grid } from '@material-ui/core';
import SearchInput from '../SearchInput';
import AfitdTypography from '../../../common/elemental/AfitdTypography';
// import avatar1 from '../../../images/adminConsole/avatar1.png';
// import avatar2 from '../../../images/adminConsole/avatar2.png';
// import avatar3 from '../../../images/adminConsole/avatar3.png';
// import avatar4 from '../../../images/adminConsole/avatar4.png';

// import { format } from 'date-fns';

import AfitdPagination from '../../../common/elemental/AfitdPagination';
import { LayoutContext } from '../../../common/contexts';
import { ADMIN_CONSOLE_PAGE_SIZE } from '../../../common/constants';
import ContactUsMessageModal from './ContactUsMessageModal';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        headerTitle: { fontWeight: 500, fontSize: 20 },
        topBarRightItem: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end' },
        passwordResetButton: { height: 36, marginRight: 8 },
        selectedText: { paddingRight: 16 },
        deleteButton: { height: 36 },
        topBarContainer: { height: 57.66, border: '1px solid #F3F3F3', padding: '0px 10px' },

        root: {
            width: '100%',
        },
        paginationContainer: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 10,
        },
        resultColumnText: { color: '#1D8A8B', cursor: 'pointer' },
        paper: {
            width: '100%',
            marginBottom: theme.spacing(2),
        },
        table: {
            minWidth: 750,
        },
        avatar: {
            width: '39px',
            borderRadius: '100px',
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1,
        },
        tableRowContainer: {
            maxHeight: 600,
            overflowY: 'scroll',
            '&::-webkit-scrollbar-track': {
                borderRadius: '10px',
                background: 'none',
            },
            '&::-webkit-scrollbar': {
                width: '8px',
                backgroundColor: '#F5F5F5',
            },
            '&::-webkit-scrollbar-thumb': {
                borderRadius: '10px',
                backgroundColor: 'rgba(0,0,0,0.2)',
            },
        },

        nameColumnText: {
            fontWeight: 'bold',
        },
        planText: {
            background: 'rgba(29, 138, 139, 0.1)',
            borderRadius: 4,
            padding: 8,
        },
    }));
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

const headCells = [
    { id: 'name', numeric: false, disablePadding: true, label: `Name` },
    { id: 'companyName', numeric: false, disablePadding: true, label: `Company` },
    { id: 'jobTitle', numeric: false, disablePadding: true, label: `Job Title` },
    { id: 'email', numeric: false, disablePadding: true, label: `Email` },
    { id: 'country', numeric: false, disablePadding: true, label: `Country` },
    { id: 'location', numeric: false, disablePadding: true, label: 'State / Province' },
    { id: 'phone', numeric: true, disablePadding: false, label: 'Phone Number' },
    { id: 'messag', numeric: true, disablePadding: false, label: 'Message' },
];

const getDefns = params => {
    const { classes } = params;

    const defns = {
        rootContainer: { item: true, xl: 9, lg: 9, md: 9, sm: 9, xs: 9 },
        passwordResetButton: { color: 'secondary' },
        topBarContainer: { container: true, alignItems: 'center' },
        topBarLeftItem: { item: true, xl: 7, xs: 7 },
        topBarRightItem: { item: true, xl: 5, xs: 5 },
        selectedText: { color: 'secondary' },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};
function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{ 'aria-label': 'select all desserts' }}
                    />
                </TableCell>
                {headCells.map((headCell, i) => (
                    <TableCell
                        key={headCell.id}
                        // align={headCell.id === 'reason' ? 'right' : 'left'}
                        // padding={headCell.id === 'result' ? 'none' : 'normal'}
                        style={{ padding: '16px 16px 16px 0px' }}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                            style={{
                                fontWeight: 'bold',
                                color: '#111E14',
                                opacity: 0.6,
                            }}
                        >
                            {headCell.label}
                            {/* {orderBy === headCell.id ? <span className={classes.visuallyHidden}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</span> : null} */}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = props => {
    const classes = useStyles(/*{param1, param2}*/)();
    // const classes = useToolbarStyles();

    const { numSelected } = props;

    const defns = getDefns({ classes, props });
    return (
        <Grid {...defns.topBarContainer}>
            <Grid {...defns.topBarLeftItem}>
                <SearchInput />
            </Grid>
            <Grid {...defns.topBarRightItem}>
                <div {...defns.selectedTextContainer}>
                    <AfitdTypography {...defns.selectedText}> {numSelected} selected</AfitdTypography>
                </div>
                <div>
                    <AfitdButton {...defns.deleteButton}>
                        <DeleteOutlineIcon />
                        &nbsp;Delete
                    </AfitdButton>
                </div>
            </Grid>
        </Grid>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const ContactUsTable = props => {
    // const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const layoutContext = useContext(LayoutContext);
    const { totalCounts } = layoutContext;
    const totalCount = totalCounts?.contactUsCount || 0;
    const [page, setPage] = React.useState(1);
    const totalPage = Math.ceil(totalCount / ADMIN_CONSOLE_PAGE_SIZE);
    // const [selected, setSelected] = React.useState([]);
    const classes = useStyles(/*{param1, param2}*/)();
    // const classes = useToolbarStyles();
    const defns = getDefns({ classes, props });
    // props
    const { selected, setSelected, /*handleFetchMore*/ data, nextOnClick, prevOnClick } = props;

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = event => {
        if (event.target.checked) {
            const newSelecteds = data.map(n => n?.uid);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }

        setSelected(newSelected);
    };
    const handleChangePage = (evt, value) => {
        if (value > page) {
            nextOnClick && nextOnClick();
        } else {
            // go to prev unless already at page 1
            if (page !== 1) prevOnClick && prevOnClick();
        }
        setPage(value);
    };

    const isSelected = name => selected.indexOf(name) !== -1;
    console.log({ data });
    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <EnhancedTableToolbar numSelected={selected.length} />

                <TableContainer>
                    <div {...defns.tableRowContainer}>
                        <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
                            <EnhancedTableHead
                                classes={classes}
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={data?.length}
                            />

                            <TableBody>
                                {stableSort(data, getComparator(order, orderBy)).map((row, index) => {
                                    const isItemSelected = isSelected(row?.uid);
                                    const labelId = `enhanced-table-checkbox-${index}`;
                                    return (
                                        <TableRow
                                            hover
                                            onClick={event => handleClick(event, row.uid)}
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={row?.uid}
                                            selected={isItemSelected}
                                        >
                                            <TableCell padding="checkbox">
                                                <Checkbox checked={isItemSelected} inputProps={{ 'aria-labelledby': labelId }} />
                                            </TableCell>

                                            <TableCell component="th" id={labelId} scope="row" padding="none" {...defns.nameColumnText}>
                                                {row?.firstName + ' ' + row?.lastName}
                                            </TableCell>

                                            <TableCell align="left" padding="none">
                                                {row.company}
                                            </TableCell>
                                            <TableCell align="left" padding="none">
                                                {row.jobTitle}
                                            </TableCell>
                                            <TableCell align="left" padding="none">
                                                {row.email}
                                            </TableCell>
                                            <TableCell align="left" padding="none">
                                                {row.country}
                                            </TableCell>
                                            <TableCell align="left" padding="none">
                                                {row.state}
                                            </TableCell>
                                            <TableCell align="left" padding="none">
                                                {row?.phone}
                                            </TableCell>

                                            <TableCell align="right" {...defns.resultColumnText}>
                                                <ContactUsMessageModal data={row} />
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </div>
                </TableContainer>
            </Paper>
            <div {...defns.paginationContainer}>
                <AfitdPagination count={totalPage} color="secondary" page={page} onChange={handleChangePage} disablePage={true} />
            </div>
        </div>
    );
};

export default ContactUsTable;
